/**
 * @desc: UI 服务
 */
import antdDialog from '../../../components/configui/dialog';
import { message as antdMsg } from 'antd';
import formatMessage from '../../../components/configui/lang';
export const SystemUi = {
    id: 'system.ui',
    alert: (msg, type = 'info', duration = 2) => {
        return new Promise((resolve) => {
            if (msg) {
                msg = formatMessage(msg);
                antdMsg[type](msg, duration);
            }
            resolve();
        });
    },
    // 同 alert
    message: (msg, type = 'info', duration = 2) => {
        return new Promise((resolve) => {
            if (msg) {
                msg = formatMessage(msg);
                antdMsg[type](msg, duration);
            }
            resolve();
        });
    },
    dialog: (id, config) => {
        return new Promise((resolve) => {
            resolve(antdDialog(id, config));
        });
    },
};
